import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Building2, Mail, Phone, Calendar } from "lucide-react";
import { cn } from "@/lib/utils";
import { format } from "date-fns";

const statusColors = {
  lead: "bg-slate-100 text-slate-700",
  prospect: "bg-blue-100 text-blue-700",
  active: "bg-emerald-100 text-emerald-700",
  inactive: "bg-amber-100 text-amber-700",
  churned: "bg-rose-100 text-rose-700",
};

const statusLabels = {
  lead: "Lead",
  prospect: "Prospekt",
  active: "Aktiv",
  inactive: "Inaktiv",
  churned: "Tapt",
};

const industryColors = {
  technology: "bg-lime-100 text-zinc-900",
  healthcare: "bg-red-100 text-red-700",
  finance: "bg-emerald-100 text-emerald-700",
  retail: "bg-orange-100 text-orange-700",
  manufacturing: "bg-slate-100 text-slate-700",
  real_estate: "bg-amber-100 text-amber-700",
  education: "bg-blue-100 text-blue-700",
  consulting: "bg-lime-100 text-zinc-900",
  other: "bg-gray-100 text-gray-700",
};

const industryLabels = {
  technology: "Teknologi",
  healthcare: "Helse",
  finance: "Finans",
  retail: "Detaljhandel",
  manufacturing: "Produksjon",
  real_estate: "Eiendom",
  education: "Utdanning",
  consulting: "Konsulent",
  other: "Annet",
};

export default function CustomerCard({ customer, onClick }) {
  return (
    <Card 
      onClick={onClick}
      className="bg-white hover:shadow-lg transition-all cursor-pointer"
    >
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-lime-100 to-lime-200 flex items-center justify-center">
              <Building2 className="w-5 h-5 text-zinc-900" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-slate-900 mb-1 truncate">{customer.company_name}</h3>
              <Badge className={cn("text-xs border-0", statusColors[customer.status])}>
                {statusLabels[customer.status] || customer.status}
              </Badge>
            </div>
          </div>
        </div>

        <div className="space-y-2 mb-4">
          {customer.contact_name && (
            <p className="text-sm text-slate-600">{customer.contact_name}</p>
          )}
          {customer.contact_email && (
            <div className="flex items-center gap-2 text-xs text-slate-500">
              <Mail className="w-3 h-3" />
              <span className="truncate">{customer.contact_email}</span>
            </div>
          )}
          {customer.contact_phone && (
            <div className="flex items-center gap-2 text-xs text-slate-500">
              <Phone className="w-3 h-3" />
              <span>{customer.contact_phone}</span>
            </div>
          )}
        </div>

        <div className="space-y-3">
          <div className="flex items-center justify-between text-xs text-slate-500">
            {customer.industry && (
              <Badge variant="outline" className={cn("text-xs border-0", industryColors[customer.industry])}>
                {industryLabels[customer.industry] || customer.industry}
              </Badge>
            )}
            {customer.deal_value && (
              <span className="font-semibold text-slate-900">
                {customer.deal_value.toLocaleString()} kr
              </span>
            )}
          </div>

          {customer.last_contact_date && (
            <div className="flex items-center gap-1 text-xs text-slate-500 pt-2 border-t border-slate-100">
              <Calendar className="w-3 h-3" />
              <span>Sist kontakt: {format(new Date(customer.last_contact_date), "d. MMM yyyy")}</span>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}